import { createColumnHelper } from '@tanstack/react-table';

import { Portfolio } from '../_openapi/portfolio-optimizer';
import { makeFieldAccessors } from '../widgets/Table/columnHelpers/makeFieldAccessors';

const columnHelper = createColumnHelper<Portfolio>();
const base = makeFieldAccessors(columnHelper, (row) => row.base);

export const portfolioListColumns = [
    base.text('pId'),
    base.date('tradeDate'),
    base.text('aC'),
    base.text('accountAlias'),
    base.text('portfolioGuid'),
    base.text('portfolioName'),
    base.text('householdName'),
    base.money('nav'),
    base.money('cash'),
    base.money('cashFuturesMargin'),
    base.text('reviewStatus'),
    base.bool('isSuspended'),
    base.date('suspendedAt'),
    base.bool('isOnboarded'),
    base.bool('isMirrorLinked'),
    base.date('linkedDate'),
    base.date('openDate'),
    base.text('referencePortfolio'),
    base.text('accountType'),
    base.bool('isTaxable'),
    base.num('effectiveTaxRate'),
    base.num('initialSecuredness', { fractionDigits: 5 }),
    base.text('ndvrPortfolioType'),
    base.bool('isTaxLossHarvesting'),
    base.bool('isDirectStock'),
    base.bool('isGlobalBeta'),
    base.bool('isPaydayBond'),
    base.bool('isGrowthBond'),
    base.bool('isBondFutures'),
    base.bool('isBondFuturesOption'),
    base.bool('isVix'),
    base.bool('isHedgedEquity'),
    base.bool('isShortTermTreasury'),
    base.bool('isClientDirected'),
    base.bool('isCashOnly'),
    base.bool('isTestAccount'),
    base.bool('isUniverseAccount'),
    base.text('brokerId'),
];
